
import ListClusterAndCompTable from "../../components/Forms/ListClusterAndCompTable";
import BasicCard from "../BasicCard";
import Dummylayout from "../Dummylayout";







function ListClusterAndComp() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
               <ListClusterAndCompTable/>
            </BasicCard>
        </>
    )
}
export default ListClusterAndComp;